export default "__VITE_ASSET__DIFEqfvI__"